import React, {useCallback} from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {useStore} from "../../../hooks/useStore";
import {useFetch} from "hooks/useFetch";
import {toTurkishProperCase} from "utils/toTurkishProperCase";
import {useObserver} from "mobx-react-lite";
import {normalizeCityName} from "utils/normalizeCityName";

const DistrictFilter = ({
    city,
    cityId,
    value,
    onChange,
    continent,
    showLabel = true,
    showAllOption = true,
    selectMarginBottom = "20px",
    allowClear = false,
    disabled = false,
    mode = undefined,
    optionMappingKey = "name"
}) => {
    const {t} = useTranslation();
    const stores = useStore();

    const normalizeCityNameString = useCallback(cityName => {
        return normalizeCityName(cityName);
    }, []);

    const [loading, districts] = useFetch({
        fetchFn: stores.optionStore.loadDistricts.bind(null, {
            cityName: normalizeCityNameString(city),
            cityId: normalizeCityNameString(cityId)
        }),
        dependencies: [city, cityId],
        initialCall: true,
        condition: (city && city !== "all") || (cityId && cityId !== "all")
    });

    return useObserver(() => (
        <React.Fragment>
            {showLabel && <h5>İlçe</h5>}
            <SelectField
                showSearch
                value={value}
                data-testid="district"
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
                disabled={disabled || ((!city || city === "all") && (!cityId || cityId === "all"))}
                mode={mode}
                loading={loading}
                filterOption={(input, option) => {
                    return (
                        option?.["data-districtname"]
                            ?.toLocaleLowerCase("TR-tr")
                            ?.indexOf(input.toLocaleLowerCase("TR-tr")) >= 0
                    );
                }}
            >
                {showAllOption && (
                    <SelectField.Option value="all">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {arrayAlphabeticalSort([...(districts || [])])
                    .filter(district => (continent ? district.continent === continent : true))
                    .map((district, i) => (
                        <SelectField.Option
                            data-testid="district_option"
                            data-districtname={district.name}
                            key={district._id || i}
                            value={district?.[optionMappingKey]
                                ?.toString()
                                ?.toLocaleLowerCase("tr-TR")}
                        >
                            {toTurkishProperCase(district.name)}
                        </SelectField.Option>
                    ))}
            </SelectField>
        </React.Fragment>
    ));
};

export default DistrictFilter;
